import { render } from "./EditSquareIcon.vue?vue&type=template&id=4866ef5c"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/EditSquareIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4866ef5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4866ef5c', __exports__)) {
    api.reload('4866ef5c', __exports__)
  }
  
  module.hot.accept("./EditSquareIcon.vue?vue&type=template&id=4866ef5c", () => {
    api.rerender('4866ef5c', render)
  })

}


export default __exports__